import { request, SSOService, requestrbac } from "./request.js";
import axios from 'axios';

// SSO API
export const userLogin = (data, headers) => {
	return SSOService({
		url: `auth/realms/SimplifyCV/protocol/openid-connect/token`, //dev
		// url: `auth/realms/SimplifyCV/protocol/openid-connect/token`, //staging and prod
		method: "post",
		headers: headers,
		data,
	});
};

export const userLogOut = (data, headers) => {
	return SSOService({
		url: `auth/realms/SimplifyCV/protocol/openid-connect/logout`,
		method: "post",
		headers: headers,
		data,
	});
};

export const keyCloakLogin=(token)=>{
    // return axios.get("https://keynode.simplifycv.com/user-access/",{
     return axios.get("https://keynode.hire3x.com/user-access/",{
        headers:{"Authorization" : `Bearer ${token}`}
    });
}

export const getLicenseKey = () => {
	return request({
		url: "/hire3x/license-gen/",
		method: "get",
	});
};

export const getUserDetails = (licenseKey) => {
	return requestrbac({
		url: "/access/userToProject",
		method: "get",
		params: {
			project: "training",
			value: "USER",
			licenseKey: licenseKey,
		},
	});
};
